import { render, staticRenderFns } from "./SocialConnectFacebook.vue?vue&type=template&id=01e5f853&"
import script from "./SocialConnectFacebook.vue?vue&type=script&lang=js&"
export * from "./SocialConnectFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports